import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { ReportFiltersValues } from '../useAnalyticsFiltersStore/types'

export const mapAnalyticsFiltersSaveParams = (
    validActiveFilters: ReportFiltersValues
) => {
    const timelineValue = parseTimelineFilter(validActiveFilters.timeline)

    const baseParams = {
        nodeIds: validActiveFilters.node,
        commodityTypeId: validActiveFilters.commodity[0],
        facilityIds: validActiveFilters.facility,
        providerIds: validActiveFilters.provider,
        contractIds: validActiveFilters.contract,
        panIds: validActiveFilters.account,
        tagIds: validActiveFilters.tag,
        usnAccountIds: validActiveFilters.usn,
        meterIds: validActiveFilters.meter,
        unitOfMeasureId: validActiveFilters.unitOfMeasureId?.[0] ?? [],
    }

    if (validActiveFilters.timeline.type === 'is') {
        return {
            ...baseParams,
            timeline: validActiveFilters.timeline.value,
        }
    } else {
        return {
            ...baseParams,
            startDate: timelineValue.startDate,
            endDate: timelineValue.endDate,
        }
    }
}
